<template>
  <v-flex
    v-if="!loading"
    xs8
    offset-xs2
    align-self-center
    justify-center
  >
  <div>
    <v-container fill-height fluid>
    <v-row>
      <v-spacer></v-spacer>
      <v-btn
        v-if="can('manage boxes')"
        @click="showBoxOutModal(0)"
        color="primary"
        dark
        class="mb-2 mr-2"
      >{{ $t("OUTING_BOXES") }}
      </v-btn>
      <v-btn
        v-if="can('manage boxes')"
        @click="showBoxInModal(0)"
        color="primary"
        dark
        class="mb-2 mr-2"
      >{{ $t("INCOMING_BOXES") }}
      </v-btn>
      <v-btn
        v-if="can('manage boxes')"
        @click="printPdf(0)"
        color="primary"
        dark
        class="mb-2 mr-2"
      >{{ $t("PRINT") }}
      </v-btn>
      <v-btn
        v-if="can('manage boxes')"
        @click="syncExcel(0)"
        color="primary"
        dark
        class="mb-2 mr-2"
      >{{ $t("SYNC_EXCEL") }}
      </v-btn>
    </v-row>
    <v-row>
      <v-flex xs3 class="mr-2 mt-6">
        <Search
          v-model="filters.search"
          :label="$t('SEARCH')"
          prepend-icon="search"
          :delay="500"
        />
      </v-flex>
      <v-flex xs3 class="mr-2 mt-6">
        <v-select
          :items="types"
          v-model="type"
          item-text="label"
          item-value="value"
          :label="$t('fields.type')"
        >
        </v-select>
      </v-flex>
      <v-flex xs2 class="ml-2">
        <InputDataPicker
          v-model="filters.date_from"
          :label="$t('fields.date_from')"
          :clearable="true"
        />
      </v-flex>

      <v-flex xs2 class="ml-2">
        <InputDataPicker
          v-model="filters.date_to"
          :label="$t('fields.date_to')"
          :clearable="true"
        />
      </v-flex>
    </v-row>

    </v-container>
    <v-data-table
      :headers="headers"
      :items="items"
      :server-items-length="totalItems"
      :no-data-text="$t('NO_DATA')"
      :no-results-text="$t('NO_DATA')"
      hide-default-footer
      :options.sync="pagination"
      :loading="loading"
      class="elevation-1"
    >
      <template v-slot:item.created_at="{ item }">
            {{ item.created_at | timeFormat }}
      </template>

      <template v-slot:item.options="{ item }">
            {{ item.options.codes }}
      </template>

      <template v-slot:item.type_shipping="{ item }">
            <span v-if="item.options.teacher">
              {{ item.options.teacher.shipping_type == 'SCHOOL' ? item.options.teacher.schools_name : item.options.teacher.shipping_type}}
            </span>
      </template>


      <template v-slot:item.actions="{ item }">
        <v-layout wrap>
              <v-flex>
                <v-btn
                  icon
                  @click="downloadPdf(item.pdf_id)"
                >
                    <v-icon>cloud_download</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
      </template>

    </v-data-table>
    <Paginator
      :total-items="totalItems"
      :page.sync="pagination.page"
      :items-per-page.sync="pagination.itemsPerPage"
      @change="fetchIncomingBoxes"
    />
  </div>
  </v-flex>
  <Loader v-else/>
</template>
<script>
  import { mapActions } from 'vuex';

  import { boxService } from '../../utils/services/box.service';
  import { reportService } from '../../utils/services/report.service';
  import Search from '../../components/shared/Inputs/Search';
  import Loader from '../../components/shared/Loader';
  import InputDataPicker from '../../components/shared/Inputs/InputDataPicker.vue';
  import Paginator from '../../components/shared/Paginator';

  import BoxInModal from '../../components/modals/Box/IncomingModal.vue';
  import BoxOutModal from '../../components/modals/Box/GoingOutModal.vue';
  import ExporDataModal from '../../components/modals/Box/ExporDataModal.vue';

  export default {
    name: 'BoxList',
    components: { Search, Loader, InputDataPicker, ExporDataModal, Paginator },
    data() {
      return {
        loading: false,
        items: [],
        types: [{ value: 'boxout', label: 'Uscita' }, { value: 'boxin', label: 'Entrata' }],
        totalItems: 0,
        pagination: {
          page: 1,
          itemsPerPage: 10,
          sortDesc: [false],
          sortBy: ['created_at'],
        },
        headers: [
          { text: this.$t('fields.created_at'), value: 'created_at' },
          { text: this.$t('fields.surname'), value: 'surname' },
          { text: this.$t('fields.name'), value: 'name' },
          { text: this.$t('fields.code'), value: 'options' },
          { text: this.$t('fields.type_shipping'), value: 'type_shipping' },
          { text: '', value: 'actions' },
        ],
        type: 'boxout',
        filters: {
          search: null,
          date_from: null,
          date_to: null,
        },
      };
    },
    computed: {
      requestFilters() {
        const filters = {
          search: this.filters.search,
          date_from: this.filters.date_from,
          date_to: this.filters.date_to,
        };
        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }
        return filters;
      },
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      ...mapActions('alert', ['showToast']),
      downloadPdf(id) {
        return reportService.downloadPdf(id);
      },

      downloadText(content) {
        const link = document.createElement('a');
        const filelog = new Blob([content], { type: 'text/plain' });
        link.href = URL.createObjectURL(filelog);
        link.download = 'log.txt';
        link.click();
        URL.revokeObjectURL(link.href);
      },

      async fetchIncomingBoxes(forcePage) {
        this.loading = true;
        const { page, itemsPerPage } = this.pagination;
        return boxService.index({
          page: page || forcePage || 1,
          itemsPerPage,
          filters: this.requestFilters,
          type: this.type,
        })
          .then(response => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
          })
          .catch(error => {
            this.handleError(error, this.errors);
          })
          .finally(() => {
            this.loading = false;
          });
      },

      showToastMessageResponse(data) {
        let { message } = data;
        let logText = '';
        const { warnings, errors } = data.moviment;

        let status = 'success';
        if (Object.entries(errors).length) {
          status = 'danger';
        } else if (Object.entries(warnings).length) {
          status = 'warning';
        }

        [
          ...Object.entries(errors),
          ...Object.entries(warnings),
        ].forEach(([key, item]) => {
          message += `<br>${key} ${item}`;
          logText += `${key} ${item}\n`;
        });

        this.showToast({ type: status, message });

        if (status !== 'success') {
          this.downloadText(logText);
        }
      },

      async showBoxOutModal(id) {
        this.showModal({
          component: BoxOutModal,
            data: {
              stored: {
                id,
              },
          },
          options: {
            title: this.$t('OUTING_BOXES'),
            onSave: (
              form,
              error,
            ) => boxService.create(form)
            .then((response) => {
              this.hideModal({});
              this.showToastMessageResponse(response.data);
            })
            .catch(error => {
              console.log(error);
              this.handleError(error, this.errors);
            })
            .finally(() => {
              this.fetchIncomingBoxes(this.pagination.page);
            }),
          },
        });
      },

      syncExcel() {
        this.loading = true;

        this.showModal({
          component: ExporDataModal,
          data: {},
          options: {
            title: this.$t('SYNC_EXCEL'),
            onSave: (
              form,
              error,
            ) => boxService.syncExcel(form)
            .then(response => {
              const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${response.data.file}`;
              const downloadLink = document.createElement('a');
              const fileName = 'text.xlsx';
              downloadLink.href = linkSource;
              downloadLink.download = fileName;
              downloadLink.target = '_blank';
              if (document.createEvent) {
                  const event = document.createEvent('MouseEvents');
                  event.initEvent('click', true, true);
                  downloadLink.dispatchEvent(event);
              } else {
                  downloadLink.click();
              }

              this.hideModal({});
          })
            .catch(error => {
              this.handleError(error, this.errors);
            })
            .finally(() => {
              this.loading = false;
            }),
          },
        });
      },

      printPdf() {
        this.loading = true;
        return boxService.index({
          filters: { ...this.requestFilters, export_pdf: true },
          type: this.type,
        })
          .then(response => {
            response.data.files.forEach((fileToDownload) => {
              const linkSource = `data:application/pdf;base64,${fileToDownload.file}`;
              const downloadLink = document.createElement('a');
              const fileName = fileToDownload.name;
              downloadLink.href = linkSource;
              downloadLink.download = fileName;
              downloadLink.target = '_blank';
              if (document.createEvent) {
                  const event = document.createEvent('MouseEvents');
                  event.initEvent('click', true, true);
                  downloadLink.dispatchEvent(event);
              } else {
                  downloadLink.click();
              }
            });
          })
          .catch(error => {
            this.handleError(error, this.errors);
          })
          .finally(() => {
            this.loading = false;
          });
      },

      async showBoxInModal(id) {
        this.showModal({
          component: BoxInModal,
            data: {
              stored: {
                id,
              },
          },
          options: {
            title: this.$t('INCOMING_BOXES'),
            onSave: (
              form,
              error,
            ) => boxService.create(form)
            .then((response) => {
              this.hideModal({});
              this.showToastMessageResponse(response.data);
            })
            .catch(error => {
              this.handleError(error, this.errors);
            })
            .finally(() => {
              this.fetchIncomingBoxes(this.pagination.page);
            }),
          },
        });
      },
    },
    async created() {
      await this.fetchIncomingBoxes(this.pagination.page);
    },
    watch: {
      filters: {
        deep: true,
        handler() {
          this.fetchIncomingBoxes(1);
        },
      },
      type: {
        handler() {
          this.fetchIncomingBoxes(1);
        },
      },
      'pagination.sortBy': {
        handler(oldVal, newVal) {
          if (newVal !== oldVal) {
            this.fetchIncomingBoxes(1);
          }
        },
      },

    },
  };
</script>
